<div class="automation-policy-editor" [formGroup]="form">
  @if (mode === 'web') {
  <div class="form-item custom-element advanced-control-item">
    <p-toggle-switch formControlName="autoclickElements"></p-toggle-switch>
    <span class="advanced-control-label">Automatically click web elements</span>
  </div>
  @if (form.get('autoclickElements')?.value) {
    <div class="form-item">
      <h4 class="form-label">Enter CSS selectors to be clicked (separated by comma)</h4>
      <div class="form-item-content select-activities">
        <input type="text" pInputText placeholder=".example-button" formControlName="autoclickElementsSelectors"/>
      </div>
    </div>
  }

  <div class="form-item custom-element advanced-control-item">
    <p-toggle-switch formControlName="autoexecJavascript"></p-toggle-switch>
    <span class="advanced-control-label">Automatically execute JavaScript</span>
  </div>
  @if (form.get('autoexecJavascript')?.value) {
    <div class="form-item">
      <h4 class="form-label">Enter the JavaScript code to be executed on the page</h4>
      <div class="form-item-content select-activities">
        <textarea pTextarea rows="5" formControlName="autoexecJavascriptCode" placeholder="console.log('Hello, World!');"></textarea>
      </div>
    </div>
    <div class="form-item">
      <h4 class="form-label">Wait for element (optional)</h4>
      <div class="form-item-content select-activities">
        <input
          pInputText
          placeholder="CSS selector to wait for"
          formControlName="autoexecJavascriptDomContainsSelector"
        />
        <small>
          If set, the automation waits until this selector exists before running your script.
        </small>
      </div>
    </div>
  }

  <div class="form-item custom-element advanced-control-item">
    <p-toggle-switch formControlName="autofillForm"></p-toggle-switch>
    <span class="advanced-control-label">Automatically fill a form</span>
  </div>

  @if (form.get('autofillForm')?.value) {
    <div class="form-item advanced-control preset-fields">
      <h4 class="form-label">Fields to fill</h4>

      <div class="field-list">
        @for (fieldGroup of fields.controls; track $index) {
          <div class="field-row" [formGroup]="$any(fieldGroup)">
            <div class="row-line">
              <div class="selector">
                <p-dropdown class="w-12rem" formControlName="targetType"
                            [options]="targetTypeOptions" optionLabel="label" optionValue="value">
                </p-dropdown>

                @switch (fieldGroup.get('targetType')?.value) {
                  @case ('selector') {
                    <input pInputText class="w-20rem" placeholder="CSS selector"
                           formControlName="targetValue"/>
                  }
                  @case ('label') {
                    <input pInputText class="w-20rem" placeholder="Label text"
                           formControlName="targetValue"/>
                  }
                  @case ('name') {
                    <input pInputText class="w-16rem" placeholder="name attribute"
                           formControlName="targetValue"/>
                  }
                  @case ('placeholder') {
                    <input pInputText class="w-20rem" placeholder="placeholder text"
                           formControlName="targetValue"/>
                  }
                }
              </div>
              <div class="value">
                <input pInputText class="w-20rem" placeholder="Value to fill"
                       formControlName="value"/>

                <p-dropdown class="w-14rem" formControlName="inputMode"
                            [options]="inputModeOptions" optionLabel="label" optionValue="value">
                </p-dropdown>

                @if (fieldGroup.get('inputMode')?.value === 'typeWithDelay') {
                  <input pInputText class="w-7rem" type="number" min="1"
                         placeholder="ms"
                         formControlName="delayMs"/>
                }

                <div class="checkbox-with-label">
                  <p-checkbox [binary]="true" formControlName="clearFirst"></p-checkbox>
                  <label>Clear</label>
                </div>

                <div class="checkbox-with-label">
                  <p-checkbox [binary]="true" formControlName="focus"></p-checkbox>
                  <label>Focus</label>
                </div>

                <button pButton severity="secondary" icon="pi pi-trash" class="ml-3"
                        (click)="removeField($index)" type="button"
                        aria-label="Remove field"></button>
              </div>
            </div>
          </div>
        }

        <button pButton label="Add field" icon="pi pi-plus" class="mt-2"
                (click)="addField()" type="button"></button>
      </div>
    </div>

    <div class="form-item">
      <h4 class="form-label">Submit behavior</h4>
      <div class="form-item-content submit-behavior" formGroupName="fillFormSubmit">
        <p-dropdown class="w-20rem" formControlName="type"
                    [options]="submitOptions" optionLabel="label" optionValue="value"></p-dropdown>

        @if (form.get('fillFormSubmit.type')?.value === 'clickSelector') {
          <input pInputText class="w-22rem" placeholder="Submit button CSS selector"
                 formControlName="selector"/>
        }

        <div class="checkbox-with-label">
          <p-checkbox formControlName="scrollIntoView"></p-checkbox>
          <label class="ml-1">Scroll fields into view</label>
        </div>
      </div>
    </div>
  }

  <div class="form-item custom-element advanced-control-item">
    <p-toggle-switch formControlName="autosetCookies"></p-toggle-switch>
    <span class="advanced-control-label">Automatically set cookies</span>
  </div>

  @if (form.get('autosetCookies')?.value) {
    <div class="form-item">
      <h4 class="form-label">Cookies</h4>

      <div class="cookie-list">
        @for (cookieGroup of cookies.controls; track $index) {
          <div class="cookie-row card p-2" [formGroup]="$any(cookieGroup)">
            <div class="row-line">
              <input pInputText class="w-18rem" placeholder="Cookie name"
                     formControlName="cookieName"/>
              <input pInputText class="w-28rem" placeholder="Cookie value"
                     formControlName="cookieValue"/>

              <div class="inline-toggle">
                <p-toggle-switch formControlName="secure"></p-toggle-switch>
                <span>Secure</span>
              </div>

              <button pButton severity="secondary" icon="pi pi-trash" class="ml-2"
                      (click)="removeCookie($index)" type="button"
                      aria-label="Remove cookie"></button>
            </div>
          </div>
        }

        <button pButton label="Add cookie" icon="pi pi-plus" class="mt-2"
                type="button" (click)="addCookie()"></button>

        <small class="hint mt-2">
          HttpOnly/Domain/Expires cannot be set from in-page JS. Use controller-side cookie APIs for those.
          Path defaults to <code>/</code>; we set <code>SameSite=Lax</code> and <code>Secure</code> on HTTPS pages.
        </small>
      </div>
    </div>
  }

  <div class="form-item custom-element advanced-control-item">
    <p-toggle-switch formControlName="autosetLocalStorage"></p-toggle-switch>
    <span class="advanced-control-label">Automatically set Local Storage</span>
  </div>

  @if (form.get('autosetLocalStorage')?.value) {
    <div class="form-item">
      <h4 class="form-label">Local Storage items</h4>

      <div class="ls-list">
        @for (storageGroup of localStorageItems.controls; track $index) {
          <div class="ls-row card p-2" [formGroup]="$any(storageGroup)">
            <div class="row-line">
              <input pInputText class="w-18rem" placeholder="Key"
                     formControlName="lsKey" />

              <input pInputText class="w-28rem" placeholder="Value"
                     formControlName="lsValue" />

              <button pButton severity="secondary" icon="pi pi-trash" class="ml-2"
                      (click)="removeLocalStorageItem($index)" type="button"
                      aria-label="Remove item"></button>
            </div>
          </div>
        }

        <button pButton label="Add item" icon="pi pi-plus" class="mt-2"
                type="button" (click)="addLocalStorageItem()"></button>

        <div class="mt-3">
          <h4 class="form-label">Only set on URLs matching (regex)</h4>
          <input pInputText class="w-full" formControlName="autolsUrlRegex"
                 placeholder="^https://(www\\.)?example\\.com/.*$" />
        </div>

        <small class="hint mt-2">
          Values are stored as strings. If you need objects, stringify them.
        </small>
      </div>
    </div>
  }
  } @else {
    <div class="form-item custom-element advanced-control-item">
      <p-toggle-switch formControlName="autoclickMobileElement"></p-toggle-switch>
      <span class="advanced-control-label">Automatically click a mobile app element</span>
    </div>

    @if (form.get('autoclickMobileElement')?.value) {
      <div class="form-item">
        <h4 class="form-label">Enter the element locator to be clicked</h4>
        <div class="form-item-content mobile-locator" formGroupName="mobileElementLocator">
          <p-dropdown class="w-14rem" formControlName="strategy"
                      [options]="mobileLocatorStrategyOptions"
                      optionLabel="label"
                      optionValue="value"
                      appendTo="body"
                      [overlayOptions]="{ baseZIndex: 1100 }"></p-dropdown>
          <input pInputText class="w-22rem" formControlName="value" placeholder="Locator value"/>
        </div>
        @if (form.hasError('mobileElementLocatorRequired')) {
          <small class="validation-error">Enter an element locator</small>
        }
      </div>
    }
  }
</div>
